import { useCallback, useEffect } from 'react';
import { useHomeHubStoreUserFlowAttributes } from '@scenes/HomeHub/store/client/homehub.store';
import { Grid } from 'ht-styleguide';

/* Hooks */
import useRouteController from '@scenes/HomeHub/hooks/hook.routeController';

/* Components */
import UserFlowHeader from '@scenes/HomeHub/pages/User/components/Header';
import UserFlowHeaderIcon from '@scenes/HomeHub/pages/User/components/ImageIcon';

/* Constants */
import { UserScreenTypes } from '@scenes/HomeHub/pages/User/index';

const UserGreetingStep = () => {
  /* Hooks / Store */
  const { nextUserRoute } = useRouteController();
  const { firstName } = useHomeHubStoreUserFlowAttributes();

  /* Methods */
  const transitionPage = useCallback(async () => {
    /* User can click back button and be within the 3 second timer */
    nextUserRoute(UserScreenTypes.email);
  }, [nextUserRoute]);

  /* Sit on page for a few seconds, then move to next step. Unmounting removes timer */
  useEffect(() => {
    const transitionTimeout = setTimeout(() => {
      transitionPage();
    }, 2000);

    return () => clearTimeout(transitionTimeout);
  }, [transitionPage]);

  return (
    <Grid.FullWidth>
      <Grid.Row>
        <Grid.Column sm={4} mdOffset={1} md={6} lg={6} lgOffset={3}>
          <UserFlowHeaderIcon width="136" height="136" imageName="smiley-face" />
          <UserFlowHeader headerText={`Nice to meet you, ${firstName}!`} />
        </Grid.Column>
      </Grid.Row>
    </Grid.FullWidth>
  );
};

export default UserGreetingStep;
